var render = function render(){var _vm=this,_c=_vm._self._c;return _c('property-form',{attrs:{"value":_vm.value,"fields":_vm.fieldDefs},on:{"input":_vm.doSave}})
}
var staticRenderFns = []

export { render, staticRenderFns }